// @ts-nocheck FIXME
import PropTypes from 'prop-types';

const MobileArtifactUpload = (props) => {
  let inputFiles = [];
  let filesInput;

  const submitFiles = () => {
    props.submitFiles(inputFiles);
  };

  const handleSelectFiles = (e) => {
    e.stopPropagation();

    if (props.handleSelectFiles) {
      props.handleSelectFiles();
    }
  };

  const handleArtifactsChange = (e) => {
    e.preventDefault();
    inputFiles = e.target.files;
    submitFiles();
  };

  // Mobile devices should see the camera option when selecting files
  return (
    <div className="hide-desktop show-phone">
      <div onClick={handleSelectFiles}>
        <form onSubmit={submitFiles}>
          <input
            className="v5__file-upload-field-mobile"
            ref={(ref) => (filesInput = ref)}
            type="file"
            onChange={handleArtifactsChange}
            multiple={props.multiple}
            accept="*"
          />
        </form>
      </div>
    </div>
  );
};

MobileArtifactUpload.propTypes = {
  submitFiles: PropTypes.func.isRequired,
  handleSelectFiles: PropTypes.func,
  multiple: PropTypes.bool.isRequired,
};

MobileArtifactUpload.defaultProps = {
  multiple: false,
};

export default MobileArtifactUpload;
